export default {
    PRINTERS: 'printers',
    COUPON: 'coupon',

    all() {
        return [
            this.PRINTERS,
            this.COUPON,
        ]
    },

    isEnabled(feature, enabledFeatures) {
        return enabledFeatures.includes(feature)
    }
}
